// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addCardButtonStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton";
import { ButtonIcon } from "@insite/mobius/Button";
import { IconWrapper } from "@tps/MobiusOverrides/Icon";
import IconMoreHover from "@tps/XDL/Icons/IconMoreHover";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

addCardButtonStyles.addCardButton = {
    variant: "primary",
    icon: {
        src: IconMoreHover,
        position: "right",
    },
    css: css`
        ${ButtonIcon} {
            top: 0;
        }
        span {
            svg {
                path {
                    fill: ${color("common.white")};
                }
            }
        }
    `,
};
